<template>
  <div class="">
    <div v-if="product.price == null">
      <div class="col-12 text-center">
        <p class="text-center btn btn-primary mx-auto rounded-pill">{{ findAttributeOnSiteInfo('setNullPrice')[0] }}</p>
      </div>
    </div>
    <div v-else>
      <div v-if="product.variation == 1">


        <select @change="calculatePriceAndOffer(product)" v-model="selectedFeature_1"
                class="custom-select custom-select-sm" id="">
          <option value="null">لطفا یکی از ویژگی های محصول را انتخاب کنید.</option>
          <option v-for="feature in productFeatures(product)"
                  :disabled="countProductFeature(product)==1 && feature.active_quantity == 0 "
                  :value="feature.id">
            {{ feature.value }}
          </option>
        </select>

        <select @change="calculatePriceAndOffer(product)" v-model="selectedFeature_2"
                v-if="!(selectedFeature_1=='null') && countProductFeature(product) == 2"
                name=""
                class="mt-3 custom-select custom-select-sm" id="">
          <option value="null">لطفا یکی از ویژگی های محصول را انتخاب کنید.</option>
          <option v-for="feature in featureValues(product)"
                  :disabled="countProductFeature(product) == 2 && feature.active_quantity == 0 " :value="feature.id">
            {{ feature.value }}
          </option>
        </select>

        <b-col class="my-3" v-if="showButtonAddToProduct(product)">
          <del v-if="offer > 0">
            <h3 class="m-auto text-muted">
              {{ formatNumber(parseInt(price)) }} تومان
            </h3>
          </del>
          <h2 class="m-auto">
            {{ formatNumber(parseInt(price - offer)) }} تومان
          </h2>
        </b-col>

        <b-btn
            v-if="showButtonAddToProduct(product)"
            pill
            @click="addToCartFunction(product,sub_product)"
            class="row text-white btn-primary">
          {{ buttonText }}
        </b-btn>

      </div>
      <div v-else>
        <del v-if="calculatePriceAndOffer(product)['offer'] > 0">
          <h3 class="m-auto text-muted">
            {{ formatNumber(parseInt(calculatePriceAndOffer(product)['price'])) }} تومان
          </h3>
        </del>
        <h2 class="m-auto">
          {{
            formatNumber(parseInt(calculatePriceAndOffer(product)['price'] - calculatePriceAndOffer(product)['offer']))
          }} تومان
        </h2>
        <b-btn
            pill
            @click="addToCartFunction(product,sub_product)"
            class="mt-4 row text-white btn-primary">
          {{ buttonText }}
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "SingleProductPrice1",
  props: {
    buttonText: {},
    addToCartFunction: {},
    product: {},
  },
  data() {
    return {
      selectedFeature_1: 'null',
      selectedFeature_2: 'null',
      offer: 0,
      price: 0,
      sub_product: null,
    }
  },
  methods: {
    productFeatures(product) {
      const product_features = product.features;
      let product_variation = [];


      for (let feature in product_features) {
        feature = product_features[feature]
        // feature.type == 'list' &&  feature.feature_values.sub_product == 1 || feature.type == 'list' && feature.feature_values.sub_product == 0 && feature.feature_values.sub_product


        if (
            feature.type == 'list' && feature.feature_values.sub_product == 1 ||
            feature.type == 'list' && feature.feature_values.sub_product == 0 && feature.feature_values.link_feature != null
        ) {

          let feature_attribute_id = feature.feature_values.feature_attribute_id;
          let feature_attributes = feature.feature_attributes

          feature_attributes.forEach(item => {
            if (item.id == feature_attribute_id) {
              product_variation.push({...item, active_quantity: feature.feature_values.active_quantity})
            }
          })


        }

      }

      var ids = [];
      var result = []

      // unique object of the list of product_variation
      product_variation.forEach((item) => {

        if (ids.indexOf(item.id) == -1) {
          ids.push(item.id)
          result.push(item)
        }

      })


      return result

    },
    featureValues(product) {

      let values = []

      const product_features = product.features;
      let product_variation = [];

      for (let feature in product_features) {
        feature = product_features[feature]
        if (feature.feature_values.link_feature_value != null) {
          if (feature.feature_values.feature_attribute_id == this.selectedFeature_1) {

            let linkFeatureAtrributeId = feature.feature_values.link_feature_value.feature_attribute_id;
            let linkFeatureAtrributs = feature.feature_values.link_feature.feature_attributes;

            linkFeatureAtrributs.forEach(item => {
              if (item.id == linkFeatureAtrributeId) {
                values.push({...item, active_quantity: feature.feature_values.active_quantity})
              }
            })

          }
        }


      }

      return values

    },
    calculatePriceAndOffer(product) {

      if (product.variation == 1) {
        const product_features = product.features;

        for (let feature in product_features) {

          feature = product_features[feature]
          if (this.countProductFeature(product) == 2) {
            if (feature.feature_values.link_feature_value != null && feature.feature_values.feature_attribute_id == this.selectedFeature_1 && feature.feature_values.link_feature_value.feature_attribute_id == this.selectedFeature_2 && feature.feature_values.variation == 1) {
              this.offer = feature.feature_values.link_feature_value.offer
              this.price = feature.feature_values.link_feature_value.price
              this.sub_product = feature.feature_values.link_feature_value;
            }
          } else if (feature.feature_values.feature_attribute_id == this.selectedFeature_1 && feature.feature_values.variation == 1) {

            this.offer = feature.feature_values.offer
            this.price = feature.feature_values.price
            this.sub_product = feature.feature_values
          }
        }
      } else {
        this.offer = product.offer
        this.price = product.price
      }

      return {
        offer: this.offer,
        price: this.price,
        sub_product: this.sub_product,
      }


    },
    showButtonAddToProduct(product) {
      //  this.selectedFeature_2 != 'null' && this.selectedFeature_1 != 'null'

      if (this.countProductFeature(product) == 2) {
        return this.selectedFeature_2 != 'null' && this.selectedFeature_1 != 'null'
      } else {
        return this.selectedFeature_1 != 'null'
      }

    },
    countProductFeature(product) {
      let count = 0;
      for (let feature in product.features) {
        feature = product.features[feature]
        if (feature.feature_values.link_feature_value == null) {
          count = 1;
        } else {
          count = 2;
        }
      }
      return count
    },
    formatNumber
  },
}
</script>

<style scoped>

</style>